export class ResetStates {
  public static readonly type = '[Organisation] ResetStates';
}
